import { API_STEPS } from "./apiSaveStep";
import { PERSONAL_DATA_FORM_FIELDS_NAMES } from "../reducers/personalDataForm";
import { SUPPLY_ADDRESS_FORM_FIELD_NAMES } from "../reducers/supplyAddressForm";
import { PAYMENT_RECAP_FIELD_NAMES } from "../reducers/paymentRecap";
import { CONSENT_FORM_FIELD_NAMES } from "../reducers/consentForm";
import { RECAP_REDUCER_FIELD_NAMES } from "../reducers/recapReducer";

export const apiFilterOutputJson = (step, form) => {
    switch (step) {
        case API_STEPS.first: {
            const body = {
                nome: form[PERSONAL_DATA_FORM_FIELDS_NAMES.name],
                cognome: form[PERSONAL_DATA_FORM_FIELDS_NAMES.surname],
                email: form[PERSONAL_DATA_FORM_FIELDS_NAMES.email],
                confermaEmail: form[PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmation],
                cellulare: form[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone],
                codiceFiscale: form[PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode],
                idOfferta: form[PERSONAL_DATA_FORM_FIELDS_NAMES.offerId],
                tipologiaOfferta: form[PERSONAL_DATA_FORM_FIELDS_NAMES.offerType],
                tempoImpiegato: form[PERSONAL_DATA_FORM_FIELDS_NAMES.timeSpent],
                privacyAccettata: form[PERSONAL_DATA_FORM_FIELDS_NAMES.isPrivacyAccepted],
                referrer: form[PERSONAL_DATA_FORM_FIELDS_NAMES.referrer],
                vivigasUID: form[PERSONAL_DATA_FORM_FIELDS_NAMES.vivigasUID],
                codiceSconto: form[PERSONAL_DATA_FORM_FIELDS_NAMES.couponCode],
                finished: "1"
            }

            if (form.otp) {
                return { ...body, otp: form.otp }
            } else {
                return body;
            }
        }
        case API_STEPS.second: {
            return {
                toponimoIndirizzo: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode],
                indirizzo: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.address],
                numeroCivico: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber],
                suffissoIndirizzo: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressSuffix],
                comune: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality],
                cap: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap],
                provincia: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province],
                attualeFornitoreLuce: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyOptionSelectedCode],
                pod: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod],
                consumoLuce: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumption],
                potenza: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPower],
                fornituraLuceCoincide: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressMatchesResidence] ? "1" : "0",
                attualeFornitoreGas: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasOptionSelectedCode],
                pdr: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr],
                consumoGas: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumption],
                fornituraGasCoincide: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressGasMatchesEnergy] ? "1" : "0",
                tempoImpiegato: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeSpent],

                toponimoIndirizzoResidenza: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode],
                indirizzoResidenza: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress],
                numeroIndirizzoResidenza: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber],
                suffissoIndirizzoResidenza: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressSuffix],
                comuneResidenza: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality],
                capResidenza: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap],
                provinciaResidenza: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince],

                indirizzoFornituraGas: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress],
                numeroIndirizzoFornituraGas: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber],
                comuneFornituraGas: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality],
                capFornituraGas: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap],
                provinciaFornituraGas: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince],

                indirizzoRecapitoCoincideConFornitura: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressMatchesSupply],
                toponimoIndirizzoRecapito: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode],
                indirizzoRecapito: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress],
                numeroIndirizzoRecapito: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber],
                suffissoIndirizzoRecapito: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoSuffix],
                comuneRecapito: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality],
                provinciaRecapito: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince],
                capRecapito: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap],

                tipologiaUsoGas: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageType],
                tipologiaUsoGasCompleta: form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeComplete],

                finished: form.finished ? "1" : "0",
                otp: form.otp,
            }
        }
        case API_STEPS.third: {
            return {                
                bollettaDigitale: form[PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill] ? "1" : "0",
                emailBollettaUgualeDatiPersonali: form[PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame] ? "1" : "0",
                emailRecapitoBolletta: form[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBill],

                metodoPagamento: form[PAYMENT_RECAP_FIELD_NAMES.paymentMethod],

                titolareContoUgualeFornitura: form[PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame] ? "1" : "0",
                titolareContoNome: form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName],
                titolareContoCognome: form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname],
                titolareContoCodiceFiscale: form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode],
                iban: form[PAYMENT_RECAP_FIELD_NAMES.iban],

                bollettinoViaIndirizzo: form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress] ? "1" : "0",
                bollettinoPostaleToponimoIndirizzo: form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode],
                bollettinoPostaleIndirizzo: form[PAYMENT_RECAP_FIELD_NAMES.billAddress],
                bollettinoPostaleNumeroCivico: form[PAYMENT_RECAP_FIELD_NAMES.billAddressNumber],
                bollettinoPostaleSuffissoIndirizzo: form[PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix],
                bollettinoPostaleComune: form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality],
                bollettinoPostaleCap: form[PAYMENT_RECAP_FIELD_NAMES.billAddressCap],
                bollettinoPostaleProvincia: form[PAYMENT_RECAP_FIELD_NAMES.billAddressProvince],
                titolareContoAccettaPrivacy: form[PAYMENT_RECAP_FIELD_NAMES.hasOwnerBankAccountPrivacy],

                tempoImpiegato: form[PAYMENT_RECAP_FIELD_NAMES.timeSpent],
                finished: form.finished ? "1" : "0",
                otp: form.otp,
            }
        }
        case API_STEPS.fourth: {
            return {
                recessoFornitore: form[CONSENT_FORM_FIELD_NAMES.acceptSwitch] ? "1" : "0",
                passaggioRapido: form[CONSENT_FORM_FIELD_NAMES.isFastSwitch] ? "1" : "0",
                accettazioneContratto: form[CONSENT_FORM_FIELD_NAMES.acceptContract] ? "1" : "0",
                noteLegali: form[CONSENT_FORM_FIELD_NAMES.acceptLegal] ? "1" : "0",
                informativaPrivacy: form[CONSENT_FORM_FIELD_NAMES.acceptPrivacy] ? "1" : "0",
                clausoleVessatorie: form[CONSENT_FORM_FIELD_NAMES.clausoleVessatorie] ? "1" : "0",
                offertaMercatoLibero: form[CONSENT_FORM_FIELD_NAMES.freeMarketOffer] ? "1" : "0",
                marketingPosta: form[CONSENT_FORM_FIELD_NAMES.marketingMailAccepted] ? "1" : "0",
                marketingTelefono: form[CONSENT_FORM_FIELD_NAMES.marketingPhoneAccepted] ? "1" : "0",
                marketingEmail: form[CONSENT_FORM_FIELD_NAMES.marketingEmailAccepted] ? "1" : "0",
                marketingElaborazione: form[CONSENT_FORM_FIELD_NAMES.marketingDataAccepted] ? "1" : "0",
                tempoImpiegato: form[CONSENT_FORM_FIELD_NAMES.timeSpent],

                finished: form.finished ? "1" : "0",
                otp: form.otp,
            }
        }
        case API_STEPS.fifth: {
            return {
                finished: form.finished,
                tempoImpiegato: form[RECAP_REDUCER_FIELD_NAMES.timeSpent],
                otp: form.otp,
            }
        }
        default: {
            return form;
        }
    }
}